export default __webpack_public_path__ + "static/media/LogoEveia.48bcc127.png";